// extracted by mini-css-extract-plugin
export var headingComponent = "headingComponent-module--headingComponent--dd2cc";
export var headingComponent__child = "headingComponent-module--headingComponent__child--ad731";